export const coreTypes = Object.seal({
    infrastructure: {
        EnvironmentClient: Symbol.for("EnvironmentClient"),
        Http: Symbol.for("Http"),
        HttpConfig: Symbol.for("HttpConfig"),
        HttpFactory: Symbol.for("HttpFactory"),
        IotApiClient: Symbol.for("IotApiClient"),
        LocalStorage: Symbol.for("LocalStorage"),
        SessionStorage: Symbol.for("SessionStorage"),
    },
    repositories: {
        EventBusRepository: Symbol.for("EventBusRepository"),
        LanguageRepository: Symbol.for("LanguageRepository"),
        ChatbotRepository: Symbol.for("ChatbotRepository"),
    },
});
